import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./PaymentSuccessful.css";

function PaymentSuccessful() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <section className="payment-success-page">
        <div className="payment-success-card">
          <div className="success-icon">✓</div>

          <h1>Payment Successful</h1>

          <p>
            Thank you for your order. Your payment has been completed
            successfully.
          </p>

          <div className="success-actions">
            <button onClick={() => navigate("/dashboard")}>
              View Orders
            </button>

            <button
              className="continue-shopping-btn"
              onClick={() => navigate("/shop-all")}
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default PaymentSuccessful;